import React from "react";
import "./App.css";
import Landing from "./components/Landing";

function App() {
  return (
    <div className="main">
      <Landing />
    </div>
  );
}

export default App;
